/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const RecommendationEvents = {
  tap: 'tap',
  view: 'view',
  aa_home_promowidget_clicked: 'aa_home_promowidget_clicked',
  aa_home_recowidget_clicked: 'aa_home_recowidget_clicked',
  Home_RecoWidget_Viewed: 'aa_home_recowidget_viewed',
  Home_Promotion_Widget_Viewed: 'aa_home_promowidget_viewed',
  View_Item_List: 'view_item_list',
  Api_Failure: 'api_error_message',
  Impression: 'recommendation_impression',
  Click: 'recommendation_click',
} as const;

export const RECOMMENDATION_SCREEN_NAME = 'HomeV2';
export const RECOMMENDATION_LIST_NAME = 'recommendationListing';
export const PROMOTION_LIST_NAME = 'promotionListing';
export const RECOMMENDATION_BASE_CURRENCY = 'MYR';
export const TRACKING_PAGE_SIZE = 5;
export const QUARTILE_PAGE_SIZE = 20;
export const VIEW_ITEM_PAGE_SIZE = 2;

export type RecommendationTrackingItem = {
  lob?: string;
  lobItemId?: string;
  itemId?: string;
  title?: string;
  deepLink?: string;
  tags?: string[];
};
